export default __webpack_public_path__ + "static/media/IconDesc_IronIngot.256.61fefcd3.png";